import { Alert, Card, Typography } from 'antd';
import EmptyState from '../../components/EmptyState';

/**
 * Page shell only. The ingestion pipeline (Phase 2 / G6) produces IngestionError records and the
 * GET /api/ingestion-errors endpoint; this page is wired to real data then.
 */
export default function IngestionErrors() {
  return (
    <Card title={<Typography.Title level={4} style={{ margin: 0 }}>خطاهای دریافت</Typography.Title>}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="این بخش پس از پیاده‌سازی خط لولهٔ دریافت (فاز ۲) به داده متصل می‌شود."
      />
      <EmptyState description="هنوز داده‌ای برای نمایش وجود ندارد." />
    </Card>
  );
}
